import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Footer } from './Footer';
import { Header } from './Header';
import { ScrollManager } from './ScrollManager';
import { CookieConsentInit } from './CookieConsentInit';

export const Layout = () => (
  <>
    <ScrollManager />
    <CookieConsentInit />
    <Toaster
      position="top-left"
      toastOptions={{
        className: 'toast',
        ariaProps: {
          role: 'status',
          'aria-live': 'polite'
        }
      }}
    />
    <a className="skip-link" href="#main-content">
      Zum Inhalt springen
    </a>
    <div id="top" />
    <Header />
    <main id="main-content" tabIndex={-1}>
      <Outlet />
    </main>
    <Footer />
  </>
);
